import React from "react";
import { formatDateTime, getRoleLabel, getStatusBadgeClass, getStatusLabel } from "./utils";

export default function ApplicationPanel({
  form,
  updateField,
  visibleProviderRoles,
  isCurrentRoleEnabled,
  disabledRoleMessages,
  currentRoleProfile,
  saving,
  handleSubmit,
  isAr,
}) {
  return (
    <div
      className="card border-0 shadow-sm mb-4 provider-center__panel-card pc-panel--application"
      id="provider-application-panel"
    >
      <div className="card-body">
        <div className="pc-section-head mb-3">
          <div className="pc-section-head__left">
            <span className="pc-icon-box pc-icon-box--green"><i className="bi bi-person-check" /></span>
            <h5 className="mb-0">{isAr ? "طلب الاعتماد" : "Apply as Provider"}</h5>
          </div>
          {currentRoleProfile ? (
            <span className={`badge rounded-pill ${getStatusBadgeClass(currentRoleProfile.status)}`}>
              {getStatusLabel(currentRoleProfile.status, isAr)}
            </span>
          ) : null}
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">{isAr ? "نوع الطلب" : "Provider Role"}</label>
            <select
              className="form-select"
              value={form.providerRole}
              disabled={visibleProviderRoles.length === 0}
              onChange={(event) => updateField("providerRole", event.target.value)}
            >
              {visibleProviderRoles.length === 0 ? (
                <option value="">
                  {isAr ? "لا توجد أقسام متاحة حاليًا" : "No provider sections are available right now"}
                </option>
              ) : null}
              {visibleProviderRoles.map((role) => (
                <option key={role} value={role}>
                  {getRoleLabel(role, isAr)}
                </option>
              ))}
            </select>
          </div>

          {visibleProviderRoles.length === 0 ? (
            <div className="alert alert-warning py-2">
              {isAr
                ? "تم تعطيل جميع أقسام مقدمي الخدمة حاليًا من الإدارة، لذلك لا يمكن إرسال طلبات جديدة الآن."
                : "All provider sections are currently disabled by the admin, so new applications are paused right now."}
            </div>
          ) : !isCurrentRoleEnabled ? (
            <div className="alert alert-warning py-2">
              {disabledRoleMessages[form.providerRole]}
            </div>
          ) : null}

          <div className="mb-3">
            <label className="form-label">{isAr ? "الاسم المعروض" : "Display Name"}</label>
            <input
              className="form-control"
              value={form.displayName}
              onChange={(event) => updateField("displayName", event.target.value)}
            />
          </div>

          <div className="mb-3">
            <label className="form-label">{isAr ? "العنوان التعريفي" : "Headline"}</label>
            <input
              className="form-control"
              value={form.headline}
              onChange={(event) => updateField("headline", event.target.value)}
            />
          </div>

          <div className="mb-3">
            <label className="form-label">{isAr ? "سنوات الخبرة" : "Experience Years"}</label>
            <input
              type="number"
              min="0"
              className="form-control"
              value={form.experienceYears}
              onChange={(event) => updateField("experienceYears", event.target.value)}
            />
          </div>

          <div className="mb-3">
            <label className="form-label">{isAr ? "نبذة" : "Bio"}</label>
            <textarea
              rows="4"
              className="form-control"
              value={form.bio}
              onChange={(event) => updateField("bio", event.target.value)}
            />
          </div>

          <div className="mb-3">
            <label className="form-label">{isAr ? "رابط الأعمال" : "Portfolio URL"}</label>
            <input
              className="form-control"
              value={form.portfolioUrl}
              onChange={(event) => updateField("portfolioUrl", event.target.value)}
            />
          </div>

          <div className="mb-3">
            <label className="form-label">{isAr ? "رابط السيرة" : "CV URL"}</label>
            <input
              className="form-control"
              value={form.cvUrl}
              onChange={(event) => updateField("cvUrl", event.target.value)}
            />
          </div>

          {form.providerRole === "employer" || form.providerRole === "seller" ? (
            <div className="mb-3">
              <label className="form-label">
                {form.providerRole === "seller"
                  ? isAr
                    ? "اسم المتجر أو النشاط"
                    : "Store or Business Name"
                  : isAr
                    ? "اسم الشركة"
                    : "Company Name"}
              </label>
              <input
                className="form-control"
                value={form.companyName}
                onChange={(event) => updateField("companyName", event.target.value)}
              />
            </div>
          ) : null}

          <button
            className="btn btn-dark w-100"
            type="submit"
            disabled={saving || visibleProviderRoles.length === 0 || !isCurrentRoleEnabled}
          >
            {saving
              ? isAr
                ? "جارٍ الإرسال..."
                : "Submitting..."
              : currentRoleProfile
                ? isAr
                  ? "تحديث الطلب"
                  : "Update Application"
                : isAr
                  ? "إرسال الطلب"
                  : "Submit Application"}
          </button>
        </form>

        {currentRoleProfile ? (
          <div className="mt-4 small text-muted">
            <div>
              {isAr ? "آخر حالة:" : "Current status:"}{" "}
              <strong>{getStatusLabel(currentRoleProfile.status, isAr)}</strong>
            </div>
            <div>
              {isAr ? "تاريخ الإرسال:" : "Submitted:"}{" "}
              {formatDateTime(currentRoleProfile.submittedAt)}
            </div>
            {currentRoleProfile.reviewedAt ? (
              <div>
                {isAr ? "تاريخ المراجعة:" : "Reviewed:"}{" "}
                {formatDateTime(currentRoleProfile.reviewedAt)}
              </div>
            ) : null}
            {currentRoleProfile.rejectionReason ? (
              <div className="text-danger mt-2">
                {isAr ? "سبب الرفض:" : "Rejection reason:"}{" "}
                {currentRoleProfile.rejectionReason}
              </div>
            ) : null}
            {currentRoleProfile.adminNotes ? (
              <div className="mt-2">
                {isAr ? "ملاحظات الإدارة:" : "Admin notes:"}{" "}
                {currentRoleProfile.adminNotes}
              </div>
            ) : null}
          </div>
        ) : (
          <div className="mt-3 small text-muted">
            {isAr
              ? "أرسل الطلب أولًا، وبعدها ستظهر لك هنا حالة الموافقة أو الرفض."
              : "Submit an application first and this area will show whether it is pending, approved, or rejected."}
          </div>
        )}
      </div>
    </div>
  );
}
